module.exports = __webpack_public_path__ + "6cac20283e2cd6c7c76d0d3a8ae35646.MP3";